<template>
  <div
    class="d-flex flex-row"
    style="height: 33px"
  >
    <div
      class="calendar-header-text w-100"
      :style="{minWidth: textColWidthPercentage + '%'}"
    >
      {{ $t('calendar.contract_title') }}
    </div>
    <div
      v-for="(week, index) in weeks"
      :key="index"
      class="calendar-header-week"
      :style="{minWidth: weekColWidth + 'px'}"
    >
      {{ week }}
    </div>
  </div>
</template>


<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
export default {
    name: 'CalendarHeader',
    mixins: [timeUtils],
    props: {
        textColWidthPercentage: {
            type: Number,
            default: 40
        },
        timeColWidth: {
            type: Number,
            default: 100  // px
        },
        stickyWeeks: {
            type: Boolean,
            default: true,
        },
        visibleWeeksLimit: {
            type: Number,
            default: 20
        },
        headerTitle: {
            type: String,
            default: null
        },
        calendarStartWeek: {
            type: Number,
            default: 70
        }
    },
    data: function () {
        return {
            start: null,
            end: null,
            weeks: []
        }
    },
    computed: {
        weekColWidth() {
            return Math.round(this.timeColWidth / 7) * 7
        }
    },
    watch: {
        calendarStartWeek: function () {
            this.initHeader()
        }
    },
    created: function () {
        this.start = new Date();
        this.end = new Date()
        this.end.setDate(this.end.getDate() + (7 * this.visibleWeeksLimit));
        this.initHeader()
    },
    methods: {
        initHeader() {
            this.weeks = []
            let startWeek = this.calendarStartWeek;
            for (let i = 0; i < this.visibleWeeksLimit; i++) {
                let weekNumber = ((startWeek+i) % 52)
                if (weekNumber === 0) {
                    weekNumber = 52
                }
                this.weeks.push(this.$t('calendar.wk_prefix') + weekNumber)
            }
        }
    }
}
</script>
<style scoped>
/* Calendar header container */
.calendar-weeks-container {
    display: flex; /* Use flex to distribute week headers */
    background: #f3f3f7; /* Set background color for header row */
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    align-items: center;
    height: 38px;
    overflow: hidden;
    white-space: nowrap;
    border-bottom: 1px solid #ddd; /* Border below the row for separation */
}

/* Sticky behavior for weeks */
.sticky-weeks {
    position: sticky;
    top: 0;
    z-index: 10;
}

/* Title Column (Same Row as Weeks) */
.calendar-header-title {
    font-size: 16px;
    font-weight: bold;
    padding: 6px 10px;
    white-space: nowrap;
    background: #f3f3f7; /* Ensure title stays consistent with the row */
    flex-shrink: 0;
    min-width: 120px; /* Fixed minimum width to keep it aligned */
}

.calendar-header-text {
    display: inline-block;
    background: #f3f3f7;
    border: 1px solid #bcbcbc;
    font-size: .9em;
    padding: .2em .5em;
    font-weight: 700;
}

.calendar-header-week {
    display: inline-block;
    background: #f3f3f7;
    border: 1px solid #bcbcbc;
    font-size: .9em;
    padding: .2em .5em;
    font-weight: 700;
}
</style>
